var _rect, _circle, _path, _circle2, _line, _circle3, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymptomsIconFig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 8,
    fill: "#5FBDD6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 9.5,
    r: 5.5,
    fill: "#F7FDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2973 18.8828C9.19459 21.9763 8.15315 27.7443 8 30H25C25 30 25 23.233 23.1622 18.8828C21.3243 14.5326 19.027 15.016 16.7297 15.016C14.4324 15.016 11.6757 15.016 10.2973 18.8828Z",
    fill: "#F7FDFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 20.5,
    r: 1.5,
    fill: "#E49152"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 20.5,
    x2: 27.5,
    y2: 20.5,
    stroke: "#E49152",
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 25.5,
    r: 1.5,
    transform: "rotate(180 16.5 25.5)",
    fill: "#E49152"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 25.5,
    x2: 5.5,
    y2: 25.5,
    stroke: "#E49152",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomsIconFig);
export default __webpack_public_path__ + "static/media/SymptomsIconFig.a6da15832882933ae738eff9540963cb.svg";
export { ForwardRef as ReactComponent };